import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.95723 0.793015C1.5667 0.402492 0.933539 0.402492 0.543015 0.793015C0.152491 1.18354 0.152491 1.81671 0.543015 2.20723L3.33585 5.00006L0.543015 7.79289C0.152491 8.18342 0.152491 8.81658 0.543015 9.20711C0.93354 9.59763 1.5667 9.59763 1.95723 9.20711L5.45717 5.70717C5.84769 5.31664 5.84769 4.68348 5.45717 4.29295L1.95723 0.793015Z"
        fill="#8E8E8E"
      />
    </svg>
  );
};

export default Svg;
